/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyFrank = createReactComponent("outline", "currency-frank", "IconCurrencyFrank", [["path", { "d": "M17 5h-6a2 2 0 0 0 -2 2v12", "key": "svg-0" }], ["path", { "d": "M7 15h4", "key": "svg-1" }], ["path", { "d": "M9 11h7", "key": "svg-2" }]]);

export { IconCurrencyFrank as default };
//# sourceMappingURL=IconCurrencyFrank.mjs.map
